export default day => `${day}`;
